import Vue from "vue";
import Vuex from "vuex";
// import modules
// import index_store
import { clearStorage, setStorage, getStorage } from "@/common/utils";
import {
  addPopularCitiy,
  decrypt,
  hot_city,
  data_fold,
  getImage,
  nature,
  uploadFile,
  getImgScream,
  clearAddresStorage,
  batchDownload,
  uploadFileOss,
} from "@/api/common";

import { policy_search_list, search_company_data } from "@/api/match";
const modulesFiles = require.context("./modules", true, /\.ts$/);
const modules: any = {};
modulesFiles.keys().map((modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
});
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    token: getStorage("token") || null, // token
    basic: getStorage("basic") || null, // basic
    // [address, addressId]
    // city: getStorage('city') || { id: "120100", name: '天津市', provinceId: "120000" },
    city: getStorage("city") || {
      id: "110100",
      name: "北京市",
      provinceId: "110000",
    },
    locationCity: getStorage("locationCity"),
    returnCitySN: getStorage("returnCitySN"),
    cityData: getStorage("cityData") || null,
    areaData: getStorage("areaData") || null,
    centerData: getStorage("centerData") || null,
    depart: getStorage("depart") || null,
    nature: getStorage("userNature") || null,
    baseUrl: "",
    whiteRouter: getStorage("whiteRouter") || ["/login", "/regist"],
    directCityList: ["110100", "120100", "310100", "500100"], // 直辖市(北京|[上海、天津、重庆])
    directProvinceList: ["110000", "120000", "310000", "500000"], // 直辖市(北京|[上海、天津、重庆])
    hotCity: getStorage("hotCity") || null, // 热门城市
    roleBasic: getStorage("roleBasic") || null, // 实名信息
    allPolicy: getStorage("allPolicy") || null, // 实名信息
  },
  modules,
  getters: {
    city: (state: any) => state.city,
    returnCityId: (state: any) =>
      state.returnCitySN && state.returnCitySN.id
        ? state.returnCitySN.id
        : null,
    returnCityIp: (state: any) =>
      state.returnCitySN && state.returnCitySN.ip
        ? state.returnCitySN.ip
        : null,
    returnCityName: (state: any) =>
      state.returnCitySN && state.returnCitySN.name
        ? state.returnCitySN.name
        : null,
    cityId: (state: any) =>
      state.city && state.city.id ? state.city.id : null,
    provinceId: (state: any) =>
      state.city && state.city.provinceId ? state.city.provinceId : null,
    cityName: (state: any) =>
      state.city && state.city.name ? state.city.name : null,
    whiteRouter: (state: any) => (state.whiteRouter ? state.whiteRouter : null),
    asyncRouter: (state: any) => (state.asyncRouter ? state.asyncRouter : null),
    token: (state: any) =>
      state.basic && state.basic.token ? state.basic.token : null,
    id: (state: any) => (state.basic && state.basic.id ? state.basic.id : null),
    unitId: (state: any) =>
      state.basic && state.basic.unitCodeId ? state.basic.unitCodeId : null,
    role: (state: any) => "unit",
    // state.basic && state.basic.idNature ? state.basic.idNature : null,
    loginState: (state: any) =>
      state.basic && state.basic.loginState ? state.basic.loginState : null,
    thisIdNature: (state: any) =>
      state.basic && state.basic.idNature ? state.basic.idNature : null,
    save: (state: any) =>
      state.basic && state.basic.save ? state.basic.save : null, // is save
    roleSave: (state: any) =>
      state.basic && (state.basic.roleSave || state.basic.soleSave)
        ? state.basic.roleSave || state.basic.soleSave
        : null, // is authern
    soleNumber: (state: any) =>
      state.baeinfo && state.basic.soleNumber ? state.basic.soleNumber : null,
    phone: (state: any) =>

      state.basic && state.basic.mobile ? state.basic.mobile : null,
    account: (state: any) =>
      state.basic && state.basic.nickName ? state.basic.nickName : null,
    company: (state: any) =>
      state.roleBasic && state.roleBasic.unitName
        ? state.roleBasic.unitName
        : null,
    registCompany: (state: any) =>
      state.basic && state.basic.company ? state.basic.company : null,
    userName: (state: any) =>

      state.basic && state.basic.username ? state.basic.username : null,
    idNumber: (state: any) =>
      state.basic && state.basic.idNumber ? state.basic.idNumber : null,
    cityData: (state: any) => state.cityData || null,
    areaData: (state: any) => state.areaData || null,
    roleBasic: (state: any) => (state.roleBasic ? state.roleBasic : {}),
  },
  mutations: {
    // address
    setAddress(state: any, data: any) {
      state.address = data;
      data ? setStorage("address", data) : clearStorage("address");
    },
    clearAddress() {
      clearStorage("address");
    },
    // baseUrl
    setBaseUrl(state: any, data: any) {
      state.baseUrl = data;
    },
    setCity(state: any, data: any) {
      if (data) {
        state.city = null;
      }
      data ? setStorage("city", data) : clearStorage("city");
      state.city = data;
    },
    setHotCity(state: any, data: any) {
      data ? setStorage("hotCity", data) : clearStorage("hotCity");
      state.hotCity = data;
    },
    setRoleBasic(state: any, data: any) {
      data ? setStorage("roleBasic", data) : clearStorage("roleBasic");
      state.roleBasic = data;
    },
    setAllPolicy(state: any, data: any) {
      data ? setStorage("allPolicy", data) : clearStorage("allPolicy");
      state.allPolicy = data;
    },
    setNature(state: any, data: any) {
      data ? setStorage("userNature", data) : clearStorage("userNature");
      state.nature = data;
    },
    setCityData(state: any, data: any) {
      data ? setStorage("cityData", data) : clearStorage("cityData");
      state.cityData = data;
    },
    setAreaData(state: any, data: any) {
      data ? setStorage("areaData", data) : clearStorage("areaData");
      state.areaData = data;
    },
    setCenterData(state: any, data: any) {
      data ? setStorage("centerData", data) : clearStorage("centerData");
      state.centerData = data;
    },
    setDepartData(state: any, data: any) {
      data ? setStorage("depart", data) : clearStorage("depart");
      state.depart = data;
    },
    setBasic(state: any, data: any) {
      data ? setStorage("basic", data) : clearStorage("basic");
      state.basic = data;
    },
  },
  actions: {
    async batchDownload({ state, commit }: any, data: any) {
      const res: any = await batchDownload(data)
        .then((res: any) => {
          return res;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async clearAddresStorage({ state, commit }: any, data: any) {
      const res: any = await clearAddresStorage()
        .then((res: any) => {
          return res;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // async addPopularCitiy({ state, commit }: any, data: any) {
    //   const res: any = await addPopularCitiy(data)
    //     .then((res: any) => {
    //       return res;
    //     })
    //     .catch((e: string) => console.error(e));
    //   return res;
    // },
    async getDecrypt({ state, commit }: any, data: any) {
      const res: any = await decrypt(data)
        .then((res: any) => {
          return res;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async searchCompanyData({ state, commit }: any, data: any) {
      const res: any = await search_company_data(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取城市信息
    async getAreaOption({ state, commit }: any) {
      // if(true) {
      const currentTime = new Date().getTime();
      if (state.areaData) {
        const { updateTime, data } = state.areaData;
        if (updateTime && updateTime > currentTime - 86400000) {
          return data;
        }
      }
      const res: any = await data_fold()
        .then()
        .catch((e: string) => console.error(e));

      const { code, data, msg } = res.data;
      const filterAreaArr = data.filter(
        (province: any) =>
          province.value !== "100000" &&
          !["台湾省", "香港特别行政区", "澳门特别行政区"].includes(
            province.label
          )
      );
      const centerData = data.find(
        (province: any) => province.value === "100000"
      );
      const updateTime = new Date().getTime();
      commit("setCenterData", centerData);
      commit("setAreaData", { data: filterAreaArr, updateTime });
      return filterAreaArr;
    },
    async getSearchList({ state, commit }: any, data: any) {
      const params = {
        ...data,
        cityName: state.city.id,
      };
      const res: any = await policy_search_list(params)
        .then((res: any) => {

          const { code, result, msg } = res.data;
          if (code === 200 && result) {
            return (
              result.map(({ name }: any) => {
                return {
                  value: name,
                  label: name,
                };
              }) || []
            );
          }
          return result || [];
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // async getHotCity({ state, commit }: any) {
    //   if (state.hotCity) {
    //     const currentTime = new Date().getTime();
    //     const { updateTime, data } = state.hotCity;
    //     if (updateTime > currentTime - 100000) {
    //       return data.filter((item: any) => item.value.name !== "北京");
    //     }
    //   }
    //   const res: any = await hot_city()
    //     .then((res: any) => {
    //       let { code, data, msg } = res.data;
    //       if (code === 0 && data) {
    //         const updateTime = new Date().getTime();
    //         data = data.filter((item: any) => item.value.name !== "北京");
    //         commit("setHotCity", { data, updateTime });
    //       }
    //       return data;
    //     })
    //     .catch((e: string) => console.error(e));
    //   return res;
    // },
    async upload({ state, commit }: any, data: any) {
      const res: any = await uploadFile(data)
        .then((res: any) => {
          const { code, data, msg } = res.data;
          if (code === 0 && data) {
            return res.data;
          }
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 上传
    async uploadFileOss({ state, commit }: any, data: any) {
      const res: any = await uploadFileOss(data)
        .then((res: any) => {
          const { code, data, msg } = res.data;
          if (code === 0 && data) {
            return res.data;
          }
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async getImage({ state, commit }: any, data: any) {
      const res: any = await getImage(data)
        .then((res: any) => {
          const { code, data, msg } = res.data;
          if (code === 0 && data) {
            return res.data;
          }
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async getImgScream({ state, commit }: any, data: any) {
      const res: any = await getImgScream(data)
        .then((res: any) => {
          const { code, data, msg } = res.data;
          if (code === 0 && data) {
            return res.data;
          }
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async getNature({ state, commit }: any) {
      if (!state.nature) {
        const res: any = await nature()
          .then((res: any) => {
            const { code, result, msg } = res.data;

            if (code === 200 && result) {
              const nature_data = result.map((item: any) => {
                const { natureName } = item;
                return {
                  value: natureName,
                  label: natureName,
                };
              });
              commit("setNature", nature_data);
              return nature_data;
            }
          })
          .catch((e: string) => console.error(e));
        return res;
      } else {
        return state.nature;
      }
    },
  },
});
